<template>
	<div class="school-job-container">
		<div class="layout">
			<div class="left-menu">
				<div class="menu-item" :class="{ active: activeJob === 'teacher' }" @click="selectJob('teacher')">
					任课教师
				</div>
				<div class="menu-item" :class="{ active: activeJob === 'prepareLeader' }" @click="selectJob('prepareLeader')">
					备课组长
				</div>
				<div class="menu-item" :class="{ active: activeJob === 'gradeLeader' }" @click="selectJob('gradeLeader')">
					年级组长
				</div>
				<div class="menu-item" :class="{ active: activeJob === 'subjectLeader' }" @click="selectJob('subjectLeader')">
					学科组长
				</div>
				<div class="menu-item" :class="{ active: activeJob === '‌department‌Leader' }" @click="selectJob('‌department‌Leader')">
					部门人员
				</div>
				<div class="menu-item" :class="{ active: activeJob === 'leader' }" @click="selectJob('leader')">
					校领导
				</div>
				<div class="menu-item" :class="{ active: activeJob === 'admin' }" @click="selectJob('admin')">
					子管理员
				</div>
			</div>

			<!-- 右边：对应内容 -->
			<div class="right-content">
				<JobTeacher v-if="activeJob === 'teacher'" />
				<JobPrepareLeader v-if="activeJob === 'prepareLeader'" />
				<JobGradeLeader v-if="activeJob === 'gradeLeader'" />
				<JobSubjectLeader v-if="activeJob === 'subjectLeader'" />
				<JobDepartment v-if="activeJob === '‌department‌Leader'" />
				<JobLeader v-else-if="activeJob === 'leader'" />
				<JobAdmin v-else-if="activeJob === 'admin'" />
				
			</div>
		</div>
	</div>
</template>

<script>
	import JobTeacher from './appointment/JobTeacher.vue'
	import JobAdmin from './appointment/JobAdmin.vue'
	import JobLeader from './appointment/JobLeader.vue'
	import JobPrepareLeader from './appointment/JobPrepareLeader.vue'
	import JobGradeLeader from './appointment/JobGradeLeader.vue'
	import JobSubjectLeader from './appointment/JobSubjectLeader.vue'
	import JobDepartment from './appointment/JobDepartment.vue'

	export default {
		name: "SchoolJob",
		components: {
			JobTeacher,//任课教师
			JobAdmin,//子管理员
			JobLeader,//校领导
			JobPrepareLeader,//备课组长
			JobGradeLeader,//年级组长
			JobSubjectLeader,//学科组长
			JobDepartment//部门人员
		},
		data() {
			return {
				activeJob: "teacher"
			};
		},
		created() {
			this.selectJob('teacher')
		},
		methods: {
			selectJob(job) {
				this.activeJob = job ||'teacher';
			}
		}
	};
</script>

<style scoped>
	.layout {
		display: flex;
		height: calc(100vh - 150px);
	}

	/* ========== 左侧菜单 ========== */
	.left-menu {
		width: 160px;
		background: #ffffff;
		border-right: 1px solid #e4e7ed;
		padding: 10px;
	}

	/* 菜单项 */
	.menu-item {
		padding: 11px 12px;
		margin-bottom: 6px;
		border-radius: 4px;
		cursor: pointer;
		text-align: center;
		font-size: 14px;
		transition: all 0.2s;
	}

	/* ========== 你的主色风格 ========== */
	.menu-item.active {
		background: #1e88e5;
		/* 你的主色 */
		color: #fff;
	}

	.menu-item:hover:not(.active) {
		background: #f3f4f7;
	}

	/* 右侧内容 */
	.right-content {
		flex: 1;
		padding: 15px;
		background: #fff;
	}
</style>